module.exports = __webpack_public_path__ + "img/Automobile.b31209d2.png";